import React, {ReactElement, useState} from 'react';

export type ReserveContextType = {
    openSection: boolean,
    setOpenSection: (value: boolean) => void
    showConfirmModal: boolean,
    setShowConfirmModal: (value: boolean) => void,
    hasError: boolean,
    setHasError: (value: boolean) => void,
}

const ReserveInitialState: ReserveContextType = {
    openSection: false,
    setOpenSection: () => {
    },
    showConfirmModal: false,
    setShowConfirmModal: () => {
    },
    hasError: false,
    setHasError: () => {

    }
}

export const ReserveContext = React.createContext<ReserveContextType>(ReserveInitialState);


export const ReserveProvider = ({children}: { children: ReactElement | ReactElement[] }): ReactElement => {
    const [openSection, setOpenSection] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [hasError, setHasError] = useState(false);

    return (
        <ReserveContext.Provider value={{
            openSection,
            setOpenSection,
            showConfirmModal,
            setShowConfirmModal,
            hasError,
            setHasError,

        }}>
            {children}
        </ReserveContext.Provider>
    );
};
